import { render, staticRenderFns } from "./LandingPageLayout.vue?vue&type=template&id=1827aa9a&scoped=true"
import script from "./LandingPageLayout.vue?vue&type=script&lang=js"
export * from "./LandingPageLayout.vue?vue&type=script&lang=js"
import style0 from "./LandingPageLayout.vue?vue&type=style&index=0&id=1827aa9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1827aa9a",
  null
  
)

export default component.exports